import { ReactNode, ChangeEvent, useCallback } from 'react';
import { FormSize } from '../../types';
import { FieldWrapper, HelperTextWrapper } from '../Field/Field';
import { Container, SwitchLabel } from './atoms';
import { InputErrorOrWarning } from '../Field/InputErrorOrWarning';
import { HiddenCheckbox } from '../common/HiddenCheckbox';

type SwitchProps = {
  name: string;
  isChecked: boolean;
  onChange: (isChecked: boolean) => void;
  isDisabled?: boolean;
  label?: string;
  'aria-label'?: string;
  helperText?: ReactNode;
  dataTestId?: string;
  formSize?: FormSize;
  alignItemsCenter?: boolean;
  errorMessage?: string;
  warningMessage?: string;
};

export const Switch = (props: SwitchProps) => {
  const {
    name,
    label,
    'aria-label': ariaLabel,
    isChecked,
    onChange,
    isDisabled,
    helperText,
    dataTestId,
    formSize,
    alignItemsCenter,
    errorMessage,
    warningMessage,
  } = props;

  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      onChange(event.target.checked);
    },
    [onChange]
  );

  return (
    <FieldWrapper
      data-test-id={dataTestId}
      $formSize={formSize}
      $alignItemsCenter={alignItemsCenter}
    >
      {helperText && <HelperTextWrapper>{helperText}</HelperTextWrapper>}
      <Container $isDisabled={isDisabled}>
        <SwitchLabel
          $isDisabled={isDisabled}
          htmlFor={name}
          $isChecked={isChecked}
          $isLabelHidden={!label}
        >
          {label}
        </SwitchLabel>
        <HiddenCheckbox
          width="34px"
          disabled={isDisabled}
          id={name}
          aria-label={!label ? ariaLabel : undefined}
          checked={isChecked}
          onChange={handleChange}
          aria-checked={isChecked}
        />
      </Container>
      <InputErrorOrWarning
        errorMessage={errorMessage}
        warningMessage={warningMessage}
      />
    </FieldWrapper>
  );
};
